
































































































































import { API } from "aws-amplify";
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { Component, Vue, Watch, Prop, PropSync, Ref } from 'vue-property-decorator';
import { Urls } from '@/Urls';
import { getModule } from 'vuex-module-decorators';
import FactorListInputDialog from '@/components/Lists/FactorListInputDialog.vue';
import { Factor, FactorGroup, FactorResource } from '@/api/model/FactorResource';
import FactorNavigation from '@/components/navigation/FactorNavigation.vue';
import Modelling from "@/store/modules/Modelling";
import Decision from '@/store/modules/Decisions';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';

import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import Scoring from '@/store/modules/Scoring';
import ScatterChart from '@/components/chart/ScatterChart.vue';
import BarChart from '@/components/chart/BarChart.vue';
import RadialBarChart from '@/components/chart/RadialBarChart.vue';

const decisionModule = getModule(Decision);
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointModule = getModule(Viewpoints);
const choiceModule = getModule(Choices);
const API_NAME = "Viewpoint360API";

@Component({
    components: {
        FactorListInputDialog,
        FactorNavigationTree: FactorNavigation,
        ScatterChart,
        BarChart,
        RadialBarChart
    },
})


export default class Insights extends Vue {
    @Prop({ default: '', type: String })
    currentViewpointId!: string;

    private searchFactors: string[] = [];
    private selectedFactors: string[] = [];
    private activeFactors: any[] = [];

    private execSummary = {};
    private mainSummary = {};

    
    
    get singularFactorLabel() {
        return decisionModule.singularFactorLabel;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree(this.startingFactors);
        }
    }

    get isFactorListActive() {
        if (workspaceOptionsModule.activeFactorLists) {
            return workspaceOptionsModule.activeFactorLists.length > 0
        }
        return false;
    }
    get barChartData() {
        return this.chartData;
    }
    get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M')
        
        } else {
            return 'M'
        }   
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    private selectFactor(payload) {
        this.selectedFactors[payload.index] = payload.factor;
        Vue.set(this.activeFactors, 'factor-' + payload.index, this.factorResources[payload.factor]);
        if ( this.dataFactors.length > 1) {
            this.getChartData()
            this.gethistogramChartDataFactorX()
            this.gethistogramChartDataFactorY()
        }
    }

    mounted() {
    
    }
    get dataFactors() {
        return Object.values(this.activeFactors);
    }

    private getSubTree(factorResourceId: string): { id: string, name?: string, children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: string[];
        if (
            factorGroup.groupTypeDefinition
            && (
                factorGroup.groupTypeDefinition.type === 'TABLE_FIXED'
            )
        ) {
            
        } else {
            
            childrenIds = this.factorResources[this.getTopGroup(factorGroup.id)].childrenIds || [];
        }
        if (!childrenIds) { childrenIds = []; }
        let children = childrenIds
            .filter(id => this.isFactorVisible(id))
            .filter(f => this.factorResources[f])
            .map((cId: string) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name
                    }
                }
                return this.getSubTree(cId)
            })

        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children
        }
    }

    private getTopGroup(topId: string) {
        if(!workspaceOptionsModule.trimTopGroups) {
            return topId;
        }

        if(this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return topId
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    private isFactorVisible(resourceId: string) {
        //If no list active or showallFactors button toggled on
        if(this.showNonListFactors || !this.isFactorListActive) {
            //return this.contributingVisibility || (!this.contributingVisibility && this.contributingFactors[resourceId])
            return true;
        }
        //If list active and showAllFactors is off, then filter 
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        } 
       
    }
    private histogramChartDataFactorX = {};

    private histogramChartDataFactorY = {};

    private chartData = {}
    //     data: {
    //         series: [],
    //     },
    //     title: {
    //         text: '',
    //     },
    //     xaxis: {},
    //     yaxis: {}
    // };

    // private histogramChartDataFactorX = {
    //     data: {
    //         series: [],
    //     }
    // };

    // private histogramChartDataFactorY = {
    //     data: {
    //         series: [],
    //     }
    // };
    get scatterChartData() {
        return this.chartData;
    }

    // get histogramChartDataFactorY() {
    //     return this.histogramChartDataFactorY
    // }

    // get histogramChartDataFactorX() {
    //     return this.histogramChartDataFactorX
    // }

    get viewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }
    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }

    private async getChartData() {
        this.chartData = {};
        try {
            if (this.decisionId && this.viewpointId && this.factors) {
                console.log('calling getTwoFactorScoreScatterChart', this.decisionId)
                const res = await getModule(Scoring).getTwoFactorScoreScatterChart({decisionId: this.decisionId, viewpointIds: this.selectedViewpointIds, viewpointId: this.activeViewpointId, factorData:this.dataFactors});
                this.chartData = res;
            }
        } catch (error) {
            console.log(error);
        }

    }
    private async gethistogramChartDataFactorX() {
        this.histogramChartDataFactorX = {};
        try {
            if (this.decisionId && this.viewpointId && this.factors) {
                console.log('calling histogramX')
                const res = await getModule(Scoring).getHistogramScoreData({decisionId: this.decisionId, viewpointId: this.activeViewpointId, factorData:this.dataFactors,factorId:this.dataFactors[0].id, viewpointIds: this.selectedViewpointIds});
                this.histogramChartDataFactorX = res;
                }
            } catch (error) {
            console.log(error);
        }
    }
    private async gethistogramChartDataFactorY() {
        this.histogramChartDataFactorY = {};
        try {
            if (this.decisionId && this.viewpointId && this.factors) {
                console.log('calling histogramY', this.decisionId)
                const res = await getModule(Scoring).getHistogramScoreData({decisionId: this.decisionId, viewpointId: this.activeViewpointId, factorData:this.dataFactors, factorId: this.dataFactors[1].id, viewpointIds: this.selectedViewpointIds});
                this.histogramChartDataFactorY = res;
                }
            } catch (error) {
            console.log(error);
        }
    }
    @Watch('dataFactors', {immediate: true, deep: true})
    onDataFactorChange() {
        if ( this.dataFactors.length > 1) {
            this.getChartData()
            this.gethistogramChartDataFactorX()
            this.gethistogramChartDataFactorY()
        }
    }
    
    private async getSummary() {
        let finalDict = {}
        let result = await VIEWPOINT_API.generateExecutiveSummary(
                    this.decisionId, 
                    this.selectedViewpointIds,
                    this.activeViewpointId
                ); 
        this.execSummary = result.executive_summary;
        this.mainSummary = result.main_body_summary;
    }
    
}
